import React from 'react';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { SkeletonItem } from '../../../common/ui/loading-skeleton/index.tsx';

export const LoadingSkeleton = () => (
	<SkeletonItem width={`${gridSize * 20}px`} height={`${gridSize * 4}px`} margin="0" />
);
